import _ from 'lodash';
import getValue from './getValue';

function getValueWithCriteria(formattedValue) {
  return /%/.test(formattedValue)
    ? getValue(formattedValue) * 100
    : getValue(formattedValue);
}

export default discount => {
  if (!_.size(discount)) return undefined;

  return _.pick(
    {
      ...discount,
      value: getValueWithCriteria(discount.formattedValue),
    },
    ['type', 'id', 'name', 'criteria', 'value']
  );
};



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/getDiscountProps.js